import { render } from "./ButtonDropdown.vue?vue&type=template&id=3f8c587c"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/ButtonDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f8c587c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f8c587c', __exports__)) {
    api.reload('3f8c587c', __exports__)
  }
  
  module.hot.accept("./ButtonDropdown.vue?vue&type=template&id=3f8c587c", () => {
    api.rerender('3f8c587c', render)
  })

}


export default __exports__